import globals from '../../globals';
import { _sendWithAxios, _sendWithAxiosBlob } from '../api'

const REACT_APP_APIADDRESS_CEP = globals.REACT_APP_APIADDRESS_CEP;

export const buscarEnderecoPorCep = async (cep) => {
    let value = cep.replace(/\-/g, "") 
    return await _sendWithAxios(`${REACT_APP_APIADDRESS_CEP}cep/${value}`, 'GET')
}
